angular
	.module('AutoPrequal')
	.controller('tradeinCtrl', tradeinCtrl);

tradeinCtrl.$inject = ['$scope', '$rootScope', '$timeout', 'ScrollFactory', 'DataFactory'];

function tradeinCtrl($scope, $rootScope, $timeout, ScrollFactory, DataFactory) {

	$rootScope.progressCurrent = 10;
	$rootScope.progressMobCurrent = 10;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.tradein;

	$scope.data = DataFactory.appData.applicant;

	$scope.nextStep = function (value) {
		if (!value) value = $scope.yesSelected ? "Y" : "N";
		DataFactory.appData.applicant.appState.tradein = true;

		if (value === "Y") {
			$scope.data.hasTradein = "Yes";
			DataFactory.setData($scope.data);
			$scope.yesSelected = true;
			$scope.noSelected = false;
			ScrollFactory.hideStep("downPayment");
			ScrollFactory.showStep("tradeinHelp");
			ScrollFactory.goToStep("tradeinHelp");
		}
		else {
			removeTradeinData();
			$scope.data.hasTradein = "No";
			DataFactory.setData($scope.data);
			$scope.yesSelected = false;
			$scope.noSelected = true;
			ScrollFactory.hideStep("tradeinHelp");
			ScrollFactory.hideStep("tradeinDetails");
			ScrollFactory.hideStep("tradeinEstimate");
			ScrollFactory.hideStep("tradeinPayments");
			$timeout(function () {
				ScrollFactory.showStep("downPayment");
				ScrollFactory.goToStep("downPayment");
			});
		}
	}

	$scope.prevStep = function () {
		ScrollFactory.showStep("reviewTerms");
		ScrollFactory.goToStep("reviewTerms");
	}

	function removeTradeinData() {
		$scope.data.apTradeinValue = "";
		$scope.data.apBalance = "";
		$scope.data.apMakingPayments = "";
		$scope.data.apTradeinDetails = "";
		$scope.data.apTradeinKms = "";
		$scope.data.tradein_avg = "";
		$scope.data.tradein_clean = "";
		$scope.data.tradein_rough = "";
		$scope.data.uvc = "";
	}
}
